import React, {Component} from 'react'
import {connect} from 'react-redux'
import * as actions from '../../state/actions'
import {bindActionCreators} from 'redux'
import {Alert} from 'react-bootstrap'
import Spinner from './../common/Spinner'
import { browserHistory } from 'react-router'
import moment from 'moment'

class TransactionDetail extends Component {

    constructor(props) {
        super(props)
        let self = this
        self.state = {

        }
    }

    componentDidMount() {
        var self = this
        self.props.actions.transactionsGetOne(self.props.params.appCodename, self.props.params.transactionId)
    }

    goBack() {
        browserHistory.go(-1)
    }

    render() {
        var self = this
        if (!self.props.transaction) {
            return (<Spinner/>)
        } else if (self.props.transaction && !self.props.transaction._id) {
            return (
                <Alert bsStyle='warning'>
                    <strong>No se encontraron productos!</strong>
                </Alert>
            )
        } else {
            let tr = self.props.transaction
            var channel = tr.channel ? tr.channel : '-'
            var customerEmail = (tr.customer && tr.customer.email) ? tr.customer.email : '-'
            var platform = tr.platform ? tr.platform : '-'
            var productDescription = (tr.product && tr.product.description) ? tr.product.description : '-'
            var productExternalId = (tr.product && tr.product.externalId) ? tr.product.externalId : '-'
            var productName = (tr.product && tr.product.name) ? tr.product.name : '-'
            var status = '-'
            if (tr.status) {
                status = tr.status
            } else if (tr.payment && tr.payment.status) {
                status = tr.payment.status
            }
            var paymentMethod = (tr.response && tr.response.paymentMethod) ? tr.response.paymentMethod : '-'
            var statusDetail = (tr.payment && tr.payment.detail) ? tr.payment.detail : '-'
            var dateTime = new Date(tr.createdAt)
            dateTime = moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
            var mercadoPagoId = (tr.payment && tr.payment.platformId) ? tr.payment.platformId : '-'
            var productAmountTotal = (tr.product && tr.product.amount) ? '$ ' + tr.product.amount : '-'
            var feePor = '-'
            var feeVal = '-'
            var amount = '-'
            if (tr.entity && tr.entity.fee && tr.product.amount) {
                feePor = tr.entity.fee + ' %'
                let valueFee = tr.product.amount * tr.entity.fee / 100
                feeVal = '$ ' + valueFee
                let am = tr.product.amount - valueFee
                amount = '$ ' + am
            }

            return (
                <div>
                    <div className='row'>
                        <div className='col-lg-12' key='infoTransaction'>
                            <h1 className='page-header'>Información de la transacción</h1>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12' key='detail'>
                            <table className='table table-bordered table-hover'>
                                <tbody>
                                    <tr className='active' key='dateTime'>
                                        <td className='col-md-2'>
                                            <b>Fecha</b>
                                        </td>
                                        <td className='col-md-10'>{dateTime}</td>
                                    </tr>
                                    <tr key='channel'>
                                        <td className='col-md-2'>
                                            <b>Channel</b>
                                        </td>
                                        <td className='col-md-10'>{channel}</td>
                                    </tr>
                                    <tr className='active' key='platform'>
                                        <td className='col-md-2'>
                                            <b>Plataforma</b>
                                        </td>
                                        <td className='col-md-10'>{platform}</td>
                                    </tr>
                                    <tr key='customerEmail'>
                                        <td className='col-md-2'>
                                            <b>Email Cliente</b>
                                        </td>
                                        <td className='col-md-10'>{customerEmail}</td>
                                    </tr>
                                    <tr className='active' key='status'>
                                        <td className='col-md-2'>
                                            <b>Estado</b>
                                        </td>
                                        <td className='col-md-10'>{status}</td>
                                    </tr>
                                    <tr className='active' key='paymentMethod'>
                                        <td className='col-md-2'>
                                            <b>Método de pago</b>
                                        </td>
                                        <td className='col-md-10'>{paymentMethod}</td>
                                    </tr>
                                    <tr key='statusDetail' style={ (status === 'rejected' || status === 'pending') ? { display: '' } : { display: 'none' }}>
                                        <td className='col-md-2'>
                                            <b>Detalle del estado</b>
                                        </td>
                                        <td className='col-md-10'>{statusDetail}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h3>Datos producto</h3>
                            <table className='table table-bordered table-hover'>
                                <tbody>
                                    <tr className='active' key='productExternalId'>
                                        <td className='col-md-2'>
                                            <b>External Id</b>
                                        </td>
                                        <td className='col-md-10'>{productExternalId}</td>
                                    </tr>
                                    <tr key='productName'>
                                        <td className='col-md-2'>
                                            <b>Nombre</b>
                                        </td>
                                        <td className='col-md-10'>{productName}</td>
                                    </tr>
                                    <tr className='active' key='productDescription'>
                                        <td className='col-md-2'>
                                            <b>Descripción</b>
                                        </td>
                                        <td className='col-md-10'>{productDescription}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h3>Datos del pago</h3>
                            <table className='table table-bordered table-hover'>
                                <tbody>
                                    <tr className='active' key='amount' style={ (amount !== '-') ? { display: '' } : { display: 'none' }}>
                                        <td className='col-md-2'>
                                            <b>Monto</b>
                                        </td>
                                        <td className='col-md-10'>{amount}</td>
                                    </tr>
                                    <tr key='feeVal' style={ (amount !== '-') ? { display: '' } : { display: 'none' }}>
                                        <td className='col-md-2'>
                                            <b>Comisión ({feePor})</b>
                                        </td>
                                        <td className='col-md-10'>{feeVal}</td>
                                    </tr>
                                    <tr className='active' key='productAmount'>
                                        <td className='col-md-2'>
                                            <b>Monto Total</b>
                                        </td>
                                        <td className='col-md-10'>{productAmountTotal}</td>
                                    </tr>
                                    <tr key='mercadoPagoId'>
                                        <td className='col-md-2'>
                                            <b>Mercado Pago Id</b>
                                        </td>
                                        <td className='col-md-10'>{mercadoPagoId}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        transaction: state.transaction
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(TransactionDetail)



// WEBPACK FOOTER //
// ./components/TransactionDetail/index.js